import { Box, Button, Container, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import apiProjects from '../../../core/api/projects/api.projects';
import Skeleton from '../../common/skeleton/skeleton';
import Headings from './../../common/headings/headings';
import { ParamProjectItem, ProjectProp } from './projectItem/model';
import ProjectItem from './projectItem/projectItem';
import ChromaGrid from '../../common/bits/chroma-grid';


export default function Projects() {
    const theme = useTheme();
    // const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
    const ltsm = useMediaQuery(theme.breakpoints.down("sm"));
    const [projects, setProject] = useState<ParamProjectItem[]>();
    const history = useHistory();

    const getData = async () => {
        let data = await apiProjects.getfbProjects();
        setProject(data)
    }
    useEffect(() => {
        getData();
    }, []);


    const navigateTo = () => {
        history.push('explore/all');
    }

    const item = () => {
        return (
          projects && (
            //   projects.slice(0, 8).map((value, key) => (
            // <div >
              <ChromaGrid items={projects.slice(0, 6)} radius={300} damping={0.45} fadeOut={0.6} ease="power3.out" />
            // </div>
          )

          // <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
          //     <div className="ui-glassmoprhic-bg ui-height--full ui-glass-shadow ui-border--r8">
          //         <Box p={4}>
          //             <ProjectItem project={value} index={key}></ProjectItem>
          //         </Box>
          //     </div>
          // </Grid>
          //   ))
        );
    }

    return (
      <div className="ui-position--relative">
        {/* <Hidden smDown>
            <BackgroundImage></BackgroundImage>
            </Hidden> */}
        <div className="ui-position--relative ui-padding--v-36 ui-z-index--1">
          <Box display="flex" flexDirection="column">
            <Container maxWidth="lg">
                <Headings heading="projects"></Headings>
            </Container>

            {/* <div className="ui-position--relative">
                        <h2 className="ui-typo--h2 ui-font-weight--medium">Projects</h2>
                            <div className="ui-padding--8"></div>
                            <p className="app-font--secondary ui-position--absolute ui-top">&lt;projects&gt;&lt;\projects&gt;</p>
                        </div> */}
            <div className="ui-padding--24"></div>

            {/* <h5 className="ui-typo--h4 ui-theme--primary ui-font-weight--normal">
                            some text about the proejcts i worked on
                        </h5> */}
            <div className="ui-padding--12"></div>
            {/* <Grid container spacing={3} direction="row" */}
            {/* justifyContent="flex-start" alignItems="stretch"> */}
            {projects && projects?.length > 0
              ? item() 
              : [1, 2, 3, 4].map((value, key) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                    <Skeleton></Skeleton>
                  </Grid>
                ))}
            {/* </Grid> */}
            <div className="ui-padding--16"></div>
            <div className={ltsm ? "ui-width--full ui-padding--h-56" : "ui-flex--justify-center"}>
              <Button className={ltsm ? "ui-width--full" : ""} variant={ltsm ? "contained" : "outlined"} size="large" color={"primary"} onClick={() => navigateTo()}>
                View All
              </Button>
            </div>
          </Box>
        </div>
      </div>
    );
}
